export default __webpack_public_path__ + "static/media/desktop_banner_personal.42c0c075.jpg";